import React from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@icons/icon.types';
import { useTranslation } from '@locales/useTranslation.hook';

function TwitterLogoIcon({ title, fillColor = '#2D3049', size = 24, ...props }: SquareSvgProps) {
  const { t } = useTranslation(['common']);
  return (
    <svg height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || t('common.share', { socialNetworkName: SocialNetwork.Twitter })}</title>
      <path
        d="M23 5.13a8.934 8.934 0 01-2.592.716 4.547 4.547 0 001.984-2.514c-.872.52-1.837.9-2.866 1.103A4.493 4.493 0 0016.232 3c-2.493 0-4.514 2.035-4.514 4.544 0 .356.04.703.117 1.036-3.75-.19-7.077-1.999-9.303-4.748a4.545 4.545 0 00-.611 2.285 4.55 4.55 0 002.008 3.782 4.478 4.478 0 01-2.045-.569v.058a4.54 4.54 0 003.62 4.455 4.51 4.51 0 01-2.038.078 4.522 4.522 0 004.216 3.156A9.016 9.016 0 011 18.958 12.706 12.706 0 007.919 21C16.22 21 20.76 14.076 20.76 8.07c0-.196-.004-.393-.013-.588A9.176 9.176 0 0023 5.131"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { TwitterLogoIcon };
